/* eslint-disable react/no-array-index-key */
import React, { lazy, Suspense, Fragment } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import MainLayout from 'src/layouts/MainLayout';
import HomeView from 'src/views/pages/HomeView';
import LoadingScreen from 'src/components/LoadingScreen';
import AuthGuard from 'src/components/AuthGuard';
import GuestGuard from 'src/components/GuestGuard';

const routesConfig = [
  {
    exact: true,
    path: '/',
    component: () => <Redirect to="/app/reports/dashboard" />
  },
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('src/views/pages/Error404View'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/login',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    path: '/app',
    guard: AuthGuard,
    layout: DashboardLayout,
    routes: [
      {
        exact: true,
        path: '/app',
        component: () => <Redirect to="/app/reports/dashboard" />
      },
      {
        exact: true,
        path: '/app/reports/dashboard',
        component: lazy(() => import('src/views/reports/DashboardView'))
      },
      {
        exact: true,
        path: '/app/reports',
        component: () => <Redirect to="/app/reports/dashboard" />
      },

      {
        exact: true,
        path: '/app/cadastros/alternative',
        component: lazy(() =>
          import('src/views/reports/DashboardAlternativeView')
        )
      },
      {
        exact: true,
        path: '/app/cadastros/esocial',
        component: lazy(() => import('src/views/Cadastros/esocial/esocialView'))
      },
      {
        exact: true,
        path: '/app/cadastros/consultaclinica',
        component: lazy(() =>
          import('src/views/Cadastros/consultasClinicas/consultasView')
        )
      },
      {
        exact: true,
        path: '/app/cadastros/agenda',
        component: lazy(() =>
          import('src/views/Cadastros/agendamento/agendamentoView')
        )
      },
      {
        exact: true,
        path: '/app/cadastros/agenda/create',
        component: lazy(() =>
          import('src/views/Cadastros/agendamento/agendamentoEditView')
        )
      },
      {
        exact: true,
        path: '/app/cadastros/agenda-credenciada',
        component: lazy(() =>
          import(
            'src/views/Cadastros/agendamentoCredenciada/agendamentoCredenciadaView'
          )
        )
      },
      {
        exact: true,
        path: '/app/cadastros/agenda-credenciada/create',
        component: lazy(() =>
          import(
            'src/views/Cadastros/agendamentoCredenciada/agendamentoCredenciadaEditView'
          )
        )
      },
      {
        exact: true,
        path: '/app/cadastros/agenda-credenciada/edit/:idAgendamento',
        component: lazy(() =>
          import(
            'src/views/Cadastros/agendamentoCredenciada/agendamentoCredenciadaEditView'
          )
        )
      },
      {
        exact: true,
        path: '/app/cadastros/funcionarios',
        component: lazy(() =>
          import('src/views/Cadastros/Funcionarios/FuncionariosView')
        )
      },
      {
        exact: true,
        path: '/app/cadastros/financeiro',
        component: lazy(() =>
          import('src/views/Cadastros/financeiro/financeiroView')
        )
      },
      {
        exact: true,
        path: '/app/cadastros/documentos',
        component: lazy(() =>
          import('src/views/Cadastros/documentos/documentosView')
        )
      },

      {
        exact: true,
        path: '/app/cadastros/proximosexames',
        component: lazy(() =>
          import('src/views/Cadastros/proximosExames/proximosExamesView')
        )
      },
      {
        exact: true,
        path: '/app/cadastros/funcionarios/edit/:idFuncionario',
        component: lazy(() =>
          import('src/views/Cadastros/Funcionarios/FuncionariosEditView')
        )
      },
      {
        exact: true,
        path: '/app/cadastros/trocarsenha',
        component: lazy(() =>
          import('src/views/Cadastros/trocarSenha/trocarSenhaEditView')
        )
      },
      {
        exact: true,
        path: '/app/cadastros/funcionarios/create',
        component: lazy(() =>
          import('src/views/Cadastros/Funcionarios/FuncionariosEditView')
        )
      },
      {
        exact: true,
        path: '/app/cadastros/notificacoes',
        component: lazy(() =>
          import('src/views/Cadastros/notificacoes/notificacoesView')
        )
      },
      {
        exact: true,
        path: '/app/cadastros/enviarDocumentos/create',
        component: lazy(() =>
          import(
            'src/views/Cadastros/enviarDocumentos/enviarDocumentosEditView'
          )
        )
      },

      {
        exact: true,
        path: '/app/teste',
        component: lazy(() => import('src/views/mail/MailView/Sidebar'))
      },

      {
        component: () => <Redirect to="/404" />
      }
    ]
  },

  {
    path: '*',
    layout: MainLayout,
    routes: [
      {
        exact: true,
        path: '/home',
        component: HomeView
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  }
];

const renderRoutes = routes =>
  routes ? (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        {routes.map((route, i) => {
          const Guard = route.guard || Fragment;
          const Layout = route.layout || Fragment;
          const Component = route.component;

          return (
            <Route
              key={i}
              path={route.path}
              exact={route.exact}
              render={props => (
                <Guard>
                  <Layout>
                    {route.routes ? (
                      renderRoutes(route.routes)
                    ) : (
                      <Component {...props} />
                    )}
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense>
  ) : null;

function Routes() {
  return renderRoutes(routesConfig);
}

export default Routes;
